import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { PlayerInput } from '@components/PlayerInput';
import { StandardWeapon } from '@components/StandardWeapon';

const ENGAGE_RANGE_FACTOR = 0.85;

/** Carries out attack orders: close to weapon range of the target, then hold and fire. */
export class AttackOrderSystem extends System {
  update(_deltaTime: number): void {
    for (const ship of this.getEntitiesWithComponents(Position, PlayerInput)) {
      const input = ship.getComponent(PlayerInput)!;
      if (input.targetEntity === null) continue;

      const target = this.world.getEntity(input.targetEntity);
      const targetPos = target?.getComponent(Position);
      if (!target || !targetPos || this.world.isPendingRemoval(target)) {
        input.targetEntity = null;
        input.pursueTarget = false;
        continue;
      }

      if (!input.pursueTarget) continue;

      const position = ship.getComponent(Position)!;
      const range = ship.getComponent(StandardWeapon)?.range ?? 150;
      const distance = Math.hypot(targetPos.x - position.x, targetPos.y - position.y);

      input.targetPosition = distance > range * ENGAGE_RANGE_FACTOR
        ? { x: targetPos.x, y: targetPos.y }
        : null;
    }
  }
}
